<script>
import FactItem from '@/components/location/FactItem.vue'
import Facts from '@/components/location/Facts.vue'
import getIoc from '@/util/ioc'
import { alpha3ToAlpha2 } from 'i18n-iso-countries'

export default {
  components: {
    FactItem,
    Facts
  },
  props: {
    /**
     * @type {import('@/types/Participant.js').Participant}
     */
    participant: {
      type: Object,
      required: true
    }
  },
  methods: {
    alpha3ToAlpha2,
    getIoc
  }
}
</script>

<template>
  <div class="card">
    <div class="card-body text-center">
      <Facts
        :header="$t('participant.infos', [participant.firstname])"
      >
        <div class="container">
          <div class="row">
            <FactItem
              :title="$t('nationality')"
            >
              <flag
                :iso="alpha3ToAlpha2(participant.nationality) || participant.nationality"
                :squared="false"
                class="mr-1"
              />
              {{ getIoc(participant.nationality) }}
            </FactItem>

            <FactItem
              :title="$t('ageGroup')"
            >
              {{ participant.ageGroup || '–' }}
            </FactItem>
          </div>
          <div class="row">
            <FactItem
              :title="$t('startNumber')"
              class="row"
            >
              <animated-number
                v-if="participant.bib"
                :value="participant.bib"
                :decimals="0"
              >
                <template #default="{ value }">#{{ value }}</template>
              </animated-number>
              <div v-else>–</div>
            </FactItem>
          </div>
        </div>
      </Facts>

      <section class="text-center mt-3">
        <a
          v-t="'participant.showProfile'"
          :href="`/${$i18n.locale}/profiles/${participant.userId}`"
          class="btn btn-outline-secondary w-100"
          target="_blank"
          rel="noopener"
        />
      </section>
    </div>
  </div>
</template>
